import { getTasksData } from "common/store/reducers/tasks";

const OPEN_STATES = [0, 1, 3, 5, 6];
const DAY_MS = 24 * 60 * 60 * 1000;

export const getOpenTasksNow = (tasksMap) => {
  const tasks = getTasksData(tasksMap);
  const now = Date.now();

  const res = {
    total: 0,
    diagnostic: 0,     // state 0
    waitingParts: 0,   // state 3
    waitingClient: 0,  // state 6
    outside: 0,        // state 1
    rma: 0,            // state 5
    stuck: 0,          // atascadas
    outsideOverdue: 0
  };

  tasks.forEach(t => {
    const state = Number(t.state);
    if (!OPEN_STATES.includes(state)) return;

    res.total++;

    if (state === 0) res.diagnostic++;
    if (state === 3) res.waitingParts++;
    if (state === 6) res.waitingClient++;
    if (state === 1) res.outside++;
    if (state === 5) res.rma++;

    // Enviadas al exterior por mas de 14 días
    if (state === 1 && t.dateEntry && (now - t.dateEntry) > 14 * DAY_MS) {
    res.outsideOverdue++;
    }

    // Atascadas: en esperando más de 7 días desde entrada
    if (
      state === 0 &&
      t.dateEntry &&
      now - t.dateEntry > 7 * DAY_MS
    ) {
      res.stuck++;
    }
  });

  return res;
};